import React, { useState, useEffect } from 'react'
import { SListTabs } from 'shj-components'
import {getAuth, getAuthTabs} from '@/utils/auth'
import SeatCommunicationCenter from './seatCommunicationCenter'
import CallManage from './callManage'

export default function CallCenter () {
  const [activeKey, setActiveKey] = useState('1')
  const [clueId, setClueId] = useState<string | number>('')
  const items = [
    {
      key: '1',
      label: '呼叫管理',
      children: <CallManage clueId={clueId} />,
      auth: 'callManage',
    },
    {
      key: '2',
      label: '通话记录',
      children: <SeatCommunicationCenter setActiveKey={setActiveKey} setClueId={setClueId} />,
      auth: 'callRecords',
    },
  ]
  const tabItems = getAuthTabs(items)
  // let tabItems = items
  useEffect(() => {
    setActiveKey(tabItems[0]?.key)
  }, [])
  return (
    <SListTabs
      activeKey={activeKey}
      onChange={k => {
        setActiveKey(k)
      }}
      items={tabItems}
      auth={getAuth()}
      hideExtra={true}
      // hideExtra={['1'].includes(activeKey)}
      tabBarStyle={{ marginBottom: 0, background: '#fff', paddingLeft: 10, paddingRight: 15 }}
    />
  )
}
